import { createFileRoute } from "@tanstack/react-router";
import { PublicTracePage } from "../components/public-trace-page";

/**
 * The address a QR on a bag carries: `portal.localhost/demo/t/{code}` locally,
 * `demo.portal.example.com/t/{code}` in production (US-24.4, decision 7).
 *
 * <p>Outside `_authed`, and that is the whole point of the split made in this story: the reader is a
 * stranger in a shop, and sending them to Keycloak would be sending them away.
 */
export const Route = createFileRoute("/t/$code")({
  component: PublicTrace,
});

function PublicTrace() {
  const { code } = Route.useParams();
  return <PublicTracePage code={code} />;
}
